export default "__VITE_PUBLIC_ASSET__4721667d__"